import { Component, OnInit, Injectable, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CalendarEvent, CalendarUtils, CalendarDateFormatter } from 'angular-calendar';
import { GetMonthViewArgs, MonthView } from 'calendar-utils';
import { addWeeks } from 'date-fns';
import { CustomDateFormatter } from '../layout-control-calendar/custom-date-formatter.provider';
import { Constants } from 'src/app/constants/constants';
import * as moment from "moment";

@Injectable()
export class WeekCalendarUtils extends CalendarUtils {
  getMonthView(args: GetMonthViewArgs): MonthView {
    args.viewStart = args.viewDate;
    args.viewEnd = addWeeks(args.viewDate, 0);
    return super.getMonthView(args);
  }
}

@Component({
  selector: 'transflo-calendar-week',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './calendar-week.component.html',
  providers: [
    {
      provide: CalendarUtils,
      useClass: WeekCalendarUtils
    },
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ]
})
export class CalendarWeekComponent implements OnInit {

  @Input() viewDate: Date;
  @Input() selectedDate: Date;
  @Input() events: CalendarEvent[];
  @Output() incrementDate = new EventEmitter();
  @Output() decrementDate = new EventEmitter();
  @Output() dayClicked = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onSwipeLeft($event) {
    this.incrementDate.emit(Constants.week);
  }

  onSwipeRight($event) {
    this.decrementDate.emit(Constants.week);
  }

  eventClicked(element: any): void {
    this.selectedDate = element.day.date;
    this.dayClicked.emit(element.day.date);
  }

  public isSelected(day): boolean {

    return moment(day).format('YYYY-MM-DD') === moment(this.selectedDate).format('YYYY-MM-DD')
  }

}
